<template>
  <div>
    
    <GdAddDevice :apiHost="apiHost"  v-if="isGd == 'true'|| isYLZ == 'true'"/>
    <AddDevice  v-if="isGd != 'true'&& isYLZ != 'true' && isCP != 'true'"/>
    <CPAddDevice :apiHost="apiHost"  v-if="isCP == 'true'"/>
    </div>
  </template>
  
  <script>
  import GdAddDevice from "../components/gdAddDevice";
  import AddDevice from "../components/addDevice";
  import CPAddDevice from "../components/CPAddDevice";

  export default {
    data() {
    return {
      apiHost:{
        path:this.$route.query.isYLZ ? 'ylzMerchant' :this.$route.query.isCP? 'canpan' : 'gdMerchant',
        urlQuery: this.$route.query.isYLZ ? "?isYLZ=true": this.$route.query.isCP ? '?isCP=true': "?isGdLl=true"
       },
      isGd: this.$route.query.isGdLl,
      isYLZ: this.$route.query.isYLZ,
      isCP: this.$route.query.isCP,
    };
  },
    components: { GdAddDevice,AddDevice, CPAddDevice },
  };
  </script>
  